import { createClient } from '@supabase/supabase-js';
import { Database } from './database.types';

const isTestEnv = import.meta.env.MODE === 'test';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || (isTestEnv ? 'https://placeholder.supabase.co' : '');
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || (isTestEnv ? 'placeholder-anon-key' : '');

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const apiClient = createClient<Database>(supabaseUrl, supabaseAnonKey);
